// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"04f22d7d","387":"cff78193","520":"8e8f87e7","544":"9ef1ae22","667":"3364a6f0","789":"700e0946","894":"1f099a5e","970":"71d3c76f"}[chunkId] + ".chunk.js";
};